<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-solution.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white banner-text mb--0">零售業服務方案</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">解決方案</h2>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/s3-1.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">全渠道客戶運營中樞</div>
						<div class="t2">
							✅ 全域數據融合：整合線上商城、小程序、線下POS等全渠道行為數據，構建客戶360°畫像，識別高價值用戶與潛在流失群體。<br>
							✅ 智能營銷決策：基於機器學習分析歷史購買與瀏覽數據，自動生成分群策略（如母嬰用戶推薦兒童食品組合）。
						</div>
					</div>
				</div>
				<div class="solution solution-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">AI驅動的營銷與銷售賦能</div>
						<div class="t2">
							✅ 個性化內容生成：自動生成適配不同渠道的圖文/視頻素材（如抖音短視頻腳本、朋友圈海報），提升內容生產效率。<br>
							✅ 銷售培訓與輔助：AI模擬客戶對話場景，培訓新人銷售應對複雜諮詢的能力，提升考核通過率。<br>
							✅ 智能客服系統：支援語音、圖像（如商品拍照識別）、文本多方式查詢，準確率95%+，替代人工客服工作量。
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/s3-2.png" style="border-radius: 12px;">
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/s3-3.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">數據驅動的供應鏈優化</div>
						<div class="t2">
							✅ 動態需求預測：融合歷史銷售、天氣、社交輿情數據，預測區域爆款（如夏季華東區冰咖需求激增）。<br>
							✅ 智能定價引擎：基於競品價格與庫存水位自動調整折扣力度，降低滯銷率降低，提升毛利率。<br>
							✅ 升級倉儲方案：通過AGV機器人+RFID技術實現揀貨效率提升3倍，降低錯單率。<br>
							✅ RaaS門店服務：清潔機器人每日自動完成貨架除塵與地面清潔，配送機器人按需運送貨品至櫃台，提升店員效率，降低人力成本。
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'

export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.solution {
	margin-top: 72px;
	display: flex;
	gap: 40px;
	.pic {
		width: 40%
	}
	.txt {
		flex: 1;
		.t1 {
			font-size: 24px;
			font-weight: 600;
			color: #000;
		}
		.t2 {
			margin-top: 12px;
			color: #000;
		}
	}
}
@media only screen and (max-width: 768px) {
	.solution {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.solution-r {
			flex-direction: column-reverse;
		}
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>

